module.exports = __webpack_public_path__ + "339d870f0efee3ad77476a1eb3761640.svg";